// Real values for the dfendpoc project, confirmed via the Firebase
// Management API (databaseUrl) and `gcloud storage buckets list`
// (storageBucket) on Aug 7, 2026 — not guessed from the standard naming
// convention. Gitignored (config/**/private) — never commit this file's
// sibling serviceAccountKey.json, and be mindful this one is low-risk to
// commit on its own but has no reason to be tracked either.
module.exports = {
  databaseURL: 'https://dfendpoc-default-rtdb.firebaseio.com',
  storageBucket: 'dfendpoc.appspot.com'
};
